import { BarInterval } from '@/services/enums';

/**
 * 时间粒度常量定义
 */

export interface TimeframeOption {
  value: BarInterval | string;
  label: string;
}

/**
 * 常用时间粒度选项
 */
export const COMMON_TIMEFRAMES: TimeframeOption[] = [
  { value: '5m', label: '5分钟' },
  { value: '15m', label: '15分钟' },
  { value: '30m', label: '30分钟' },
  { value: '1H', label: '1小时' },
  { value: '4H', label: '4小时' },
  { value: '1D', label: '1天' },
];
